import { WorkaroundDefinedType } from '../../../../../shared/types/business-functions-workarounds';

export const commonFormFields = [
  {
    key: 'mto',
    label: 'Maximum Tolerated Outage',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    disabled: true,
  },
  {
    key: 'rto',
    label: 'Recovery Time Objective (RTO)',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    disabled: true,
  },
  {
    key: 'rpo',
    label: 'Recovery Point Objective (RPO)',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    disabled: true,
  },
  {
    key: 'sla',
    label: 'Service Level Agreement (SLA)',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    disabled: true,
  },
  {
    key: 'isWorkaroundNeeded',
    label: 'Workaround Needed?',
    type: 'boolean',
  },
  {
    key: 'workaroundDefined',
    label: 'Workaround Defined',
    type: 'select',
    defaultValue: WorkaroundDefinedType.NO_WORKAROUND,
    isRequired: true,
    options: [
      {
        value: WorkaroundDefinedType.NO_WORKAROUND,
        label: 'No Workaround',
      },
      {
        value: WorkaroundDefinedType.INFINITE,
        label: 'Infinite',
      },
      {
        value: WorkaroundDefinedType.DEFINED_TIME,
        label: 'Defined Time',
      },
    ],
  },
  {
    key: 'runtimeHours',
    label: 'Runtime with Workaround',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    isRequired: false,
  },
  {
    key: 'maxDataLossHours',
    label: 'Max. Allowable Data Loss',
    type: 'time',
    decoratorWord: 'hours',
    defaultValue: 0,
    isRequired: false,
  },
  {
    key: 'workaroundDescription',
    label: 'Workaround Description',
    type: 'textArea',
    defaultValue: '',
    isRequired: false,
  },
];
